var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AtendimentoManage',{attrs:{"uuidFrom":_vm.$route.params.uuid != undefined ? _vm.$route.params.uuid : '',"reloadData":_vm.reloadData},on:{"saved":_vm.redirectToPage,"voltar":function($event){return _vm.$router.push({ name: 'ven-atendimento-list' })},"isChanged":function($event){_vm.isChanged = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }